// @generated by protoc-gen-es v1.3.0 with parameter "target=ts"
// @generated from file activity/v1/muscle_share.proto (package activity.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message activity.v1.MuscleShare
 */
export class MuscleShare extends Message<MuscleShare> {
  /**
   * @generated from field: string muscle_id = 1;
   */
  muscleId = "";

  /**
   * @generated from field: double intensity = 2;
   */
  intensity = 0;

  constructor(data?: PartialMessage<MuscleShare>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "activity.v1.MuscleShare";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "muscle_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "intensity", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MuscleShare {
    return new MuscleShare().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MuscleShare {
    return new MuscleShare().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MuscleShare {
    return new MuscleShare().fromJsonString(jsonString, options);
  }

  static equals(a: MuscleShare | PlainMessage<MuscleShare> | undefined, b: MuscleShare | PlainMessage<MuscleShare> | undefined): boolean {
    return proto3.util.equals(MuscleShare, a, b);
  }
}

